import Vue from "vue";
import ColorView from "color-view";
import AnyFormat from "../lib/any-format.js";
import server from "../remotes/server.js";

Vue.use(ColorView);
Vue.use(AnyFormat);

// v-focus：自动获取焦点
Vue.directive('focus', {
    inserted: function (el) {
        el.focus();
    }
});

Vue.prototype.$remotes = {
    server
};

Vue.config.productionTip = false;

export default Vue;
